module.exports = __webpack_public_path__ + "static/media/escritorio.0173af78.jpg";